import React, { useState } from "react";
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import {
  FaChevronDown,
  FaMoneyBillAlt,
  FaGift,
  FaCalendarAlt,
} from "react-icons/fa";
import { transformDate } from "../../../utils/date.formate";

const CardDon = ({ donation }) => {
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const donsFiltres =
    donation?.dons?.filter((d) => d?.date_du_don?.includes(search)) || [];
  const totalMontant =
    donsFiltres.reduce((acc, don) => acc + parseInt(don?.montant), 0) || 0;

  return (
    <Accordion
      expanded={expanded === "panel1"}
      onChange={handleChange("panel1")}
      style={{
        width: "31%",
        borderRadius: "8px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        overflow: "hidden", 
        height: expanded ? "auto" : "100px", 
      }}
      multiple={false}
    >
      <AccordionSummary
        expandIcon={<FaChevronDown />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="150%"
        >
          <Box>
            <Typography component="div">
              <strong>Nom:</strong> {donation?.donateur?.name}{" "}
              {donation?.donateur?.surname}
            </Typography>
            <Typography component="div">
              <strong>Fiantso:</strong> {donation?.donateur?.fiantso}
            </Typography>
            <Typography component="div">
              <strong>Finday:</strong> {donation?.donateur?.phone}
            </Typography>
          </Box>
          <Box
            style={{
              marginRight: "10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <input
              type="date"
              onChange={(e) => setSearch(e.target.value.toLocaleLowerCase())}
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid lightgray",
              }}
            />
            <Typography
              variant="body2"
              style={{
                marginTop: "10px",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center", // Alignement vertical au centre
              }}
            >
              <FaMoneyBillAlt
                style={{ marginRight: "6.5px", fontSize: "20px" }}
              />
              Total: {totalMontant}Ar
            </Typography>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        {donsFiltres.map((dond, index) => (
          <Box
            style={{
              marginBottom: "10px",
              borderBottom: "2px solid lightgrey",
              paddingBottom: "5px",
            }}
          >
            <Typography
              style={{
                display: "flex",
                alignItems: "center", // Alignement vertical au centre
              }}
            >
              <FaCalendarAlt
                style={{ marginRight: "6.5px", fontSize: "20px" }}
              />
              {transformDate(dond?.date_du_don)}
            </Typography>
            <Typography
              style={{
                display: "flex",
                alignItems: "center", // Alignement vertical au centre
              }}
            >
              <FaMoneyBillAlt
                style={{ marginRight: "6.5px", fontSize: "20px" }}
              />
              {dond?.montant}Ar
            </Typography>
            <Typography
              style={{
                display: "flex",
                alignItems: "center", // Alignement vertical au centre
              }}
            >
              <FaGift style={{ marginRight: "6.5px", fontSize: "20px" }} />
              {dond?.type_de_transfert}
            </Typography>
          </Box>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default CardDon;
